import { render } from "./Create25Liquidation4.vue?vue&type=template&id=6e0ab538"
import script from "./Create25Liquidation4.vue?vue&type=script&lang=js"
export * from "./Create25Liquidation4.vue?vue&type=script&lang=js"

import "./Create25Liquidation4.vue?vue&type=style&index=0&id=6e0ab538&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__